webpackJsonp([53],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return infoRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return questionRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return questionOptionRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的分步模板ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {};

var infoRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请填写题目标题'))]
};

var questionRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请填写题目标题'))],
  options: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请至少添加一个选项', 'array'))]
};
var questionOptionRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请填写选项标题'))],
  images: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传图片', 'array'))]
};

/***/ }),

/***/ 2988:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__step_template_rules_js__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_step_template_components_StepTemplateLog__ = __webpack_require__(5433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_step_template_components_StepTemplateAsrBindDialog__ = __webpack_require__(5441);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { StepTemplateLog: __WEBPACK_IMPORTED_MODULE_4__views_step_template_components_StepTemplateLog__["a" /* default */], StepTemplateAsrBindDialog: __WEBPACK_IMPORTED_MODULE_5__views_step_template_components_StepTemplateAsrBindDialog__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__["a" /* default */]],
  data: function data() {
    return {
      searchRules: __WEBPACK_IMPORTED_MODULE_1__step_template_rules_js__["e" /* searchRules */],
      search: {
        keyword: null,
        createName: null,
        type: this.$route.params.type || 0 // 分步模板类型
      },
      visibleLogDialog: false,
      stepTemplateId: null,
      asrBindDialogVisible: false,
      asrBindRow: null,
      exportHeader: [{
        key: 'id',
        text: '分步模板ID'
      }, {
        key: 'name',
        text: '分步模板名称'
      }, {
        key: 'created_at',
        text: '添加日期'
      }]
    };
  },

  computed: Vuex.mapState({
    users: function users(state) {
      return state.login.user;
    }
  }),
  created: function created() {
    console.log(this.users);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getStepTemplateTable', params);
    },
    onExportPage: function onExportPage() {
      this.$export(this.$route.meta.title + '-' + this.pagination.current_page + 'P', this.table, {
        fileHeader: this.exportHeader
      });
    },
    onExportSearch: function onExportSearch() {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('getStepTemplateTable', params);
        })
      });
    },
    onExportRows: function onExportRows(id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: function (_request2) {
          function request(_x2) {
            return _request2.apply(this, arguments);
          }

          request.toString = function () {
            return _request2.toString();
          };

          return request;
        }(function (params) {
          return request('exportStepTemplateData', params);
        }),
        requestParams: { id: id },
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    onDelete: function onDelete(id) {
      var _this = this;

      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', { type: 'warning' }).then(function () {
        request.common('deleteStepTemplateData', { id: id }).then(function () {
          _this.$message.success('删除成功');
          _this.onSearch();
        });
      }).catch(function () {
        _this.$message.info('已取消删除');
      });
    },
    onCopy: function onCopy(id) {
      var _this2 = this;

      request.common('copyStepTemplateData', { id: id }).then(function () {
        _this2.$message.success('复制成功');
        _this2.onSearch();
      });
    },
    onBatchUpdateTask: function onBatchUpdateTask(id) {
      var _this3 = this;

      this.$confirm('确认批量更新?', '提示', { type: 'warning' }).then(function () {
        var detail = {
          displayName: '模板ID',
          taskType: 234,
          file_type: 9,
          collection_type: 2,
          id: id
        };
        request.common('createExecuteTaskBatch', detail).then(function () {
          _this3.$message.success('批量更新成功,请前往批量任务查看');
          _this3.onSearch();
        });
      }).catch(function () {
        _this3.$message.info('已取消');
      });
    },
    formatDate: function formatDate(value) {
      return filter.formatUnix(value);
    },
    formatAsrConfigLabel: function formatAsrConfigLabel(row) {
      if (!row) {
        return '-';
      }
      var title = row.audio_asr_check_template_title == null || row.audio_asr_check_template_title === '' ? '' : String(row.audio_asr_check_template_title);
      var id = row.audio_asr_check_template_id == null || Number(row.audio_asr_check_template_id) === 0 ? '' : String(row.audio_asr_check_template_id);
      if (title && id) {
        return title + ' / ' + id;
      }
      return title || id || '-';
    },
    openVisibleLogDialog: function openVisibleLogDialog(id) {
      this.visibleLogDialog = true;
      this.stepTemplateId = id;
    },
    openAsrBindDialog: function openAsrBindDialog(row) {
      this.asrBindRow = row;
      this.asrBindDialogVisible = true;
    }
  })
});

/***/ }),

/***/ 2989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: false
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      log: ''
    };
  },

  computed: {},
  watch: {
    visible: function visible() {
      if (this.currentVisible !== this.visible) {
        this.log = null;
        this.currentVisible = this.visible;
        if (this.currentVisible) {
          this.getLog();
        }
      }
    },
    currentVisible: function currentVisible() {
      if (this.currentVisible !== this.visible) {
        this.$emit('update:visible', this.currentVisible);
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getLog: function getLog() {
      var _this = this;

      request.common('getStepTemplateLog', { id: this.id }).then(function (_ref) {
        var data = _ref.data;

        _this.log = data;
      });
    }
  }
});

/***/ }),

/***/ 2990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StepTemplateAsrBindDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    substepId: {
      type: [Number, String],
      default: null
    },
    rowTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      saving: false,
      asrTemplateId: null,
      boundTemplateId: null
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        this.$emit('update:visible', value);
      }
    },
    viewConfigId: function viewConfigId() {
      var id = this.asrTemplateId || this.boundTemplateId;
      return id && Number(id) > 0 ? id : null;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['queryAudioAsrCheckTemplateSelect', 'getAudioAsrCheckTemplate', 'getAudioAsrCheckBindBySubstep', 'bindAudioAsrCheckTemplate', 'unbindAudioAsrCheckTemplate']), {
    onOpen: function onOpen() {
      this.loadBind();
    },
    onClose: function onClose() {
      this.asrTemplateId = null;
      this.boundTemplateId = null;
    },
    loadBind: function loadBind() {
      var _this = this;

      if (!this.substepId) {
        return;
      }
      this.loading = true;
      request.common('getAudioAsrCheckBindBySubstep', { substepid: this.substepId }).then(function (_ref) {
        var data = _ref.data;

        if (data && data.audio_asr_check_template_id) {
          _this.asrTemplateId = Number(data.audio_asr_check_template_id);
          _this.boundTemplateId = Number(data.audio_asr_check_template_id);
        } else {
          _this.asrTemplateId = null;
          _this.boundTemplateId = null;
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (!this.substepId) {
        return;
      }
      var nextId = this.asrTemplateId ? Number(this.asrTemplateId) : 0;
      var currentId = this.boundTemplateId ? Number(this.boundTemplateId) : 0;
      if (nextId === currentId) {
        this.dialogVisible = false;
        return;
      }

      this.saving = true;
      var req = nextId ? request.common('bindAudioAsrCheckTemplate', {
        substepid: this.substepId,
        audio_asr_check_template_id: nextId
      }) : request.common('unbindAudioAsrCheckTemplate', this.substepId);

      req.then(function () {
        _this2.$message.success(nextId ? '绑定成功' : '已解除绑定');
        _this2.$emit('success');
        _this2.dialogVisible = false;
      }).finally(function () {
        _this2.saving = false;
      });
    }
  })
});

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateTable_vue__ = __webpack_require__(2988);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd2c426_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateTable_vue__ = __webpack_require__(5445);
function injectStyle (ssrContext) {
  __webpack_require__(5427)
  __webpack_require__(5429)
  this["$style"] = __webpack_require__(5431)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bd2c426"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd2c426_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5427:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7f102aab", content, true, {});

/***/ }),

/***/ 5428:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5429:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5430);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a1bd0522", content, true, {});

/***/ }),

/***/ 5430:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".step-template-asr-config-link[data-v-7bd2c426]{display:inline-block;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:bottom}.step-template-asr-config-link ::v-deep .el-link[data-v-7bd2c426]{display:inline;font-size:inherit}", "", {"version":3,"sources":["/workspace/src/views/step-template/pages/StepTemplateTable.vue"],"names":[],"mappings":"AACA,gDAAgD,qBAAqB,eAAe,gBAAgB,uBAAuB,mBAAmB,qBAAqB,CAClK,AACD,kEAAkE,eAAe,iBAAiB,CACjG","file":"StepTemplateTable.vue","sourcesContent":["\n.step-template-asr-config-link[data-v-7bd2c426]{display:inline-block;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:bottom\n}\n.step-template-asr-config-link ::v-deep .el-link[data-v-7bd2c426]{display:inline;font-size:inherit\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5431:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5432);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("01fbbebe", content, true, {});

/***/ }),

/***/ 5432:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateLog_vue__ = __webpack_require__(2989);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25276920_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateLog_vue__ = __webpack_require__(5440);
function injectStyle (ssrContext) {
  __webpack_require__(5434)
  __webpack_require__(5436)
  this["$style"] = __webpack_require__(5438)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25276920"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25276920_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5434:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4bb0dcb6", content, true, {});

/***/ }),

/***/ 5435:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateLog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5436:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5437);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("453dfff0", content, true, {});

/***/ }),

/***/ 5437:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateLog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5438:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5439);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6c04b500", content, true, {});

/***/ }),

/***/ 5439:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateLog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"LOG记录查看","visible":_vm.currentVisible,"width":"50%"},on:{"update:visible":function($event){_vm.currentVisible=$event}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.log)}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateAsrBindDialog_vue__ = __webpack_require__(2990);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efe259ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateAsrBindDialog_vue__ = __webpack_require__(5444);
function injectStyle (ssrContext) {
  __webpack_require__(5442)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-efe259ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateAsrBindDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efe259ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateAsrBindDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5442:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5443);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("bcd6a858", content, true, {});

/***/ }),

/***/ 5443:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".asr-bind-dialog__meta[data-v-efe259ce]{margin-bottom:16px;color:#606266;font-size:13px;line-height:1.8}.asr-bind-dialog__tip[data-v-efe259ce]{margin-top:4px;color:#909399;font-size:12px}.width-max[data-v-efe259ce]{width:100%}", "", {"version":3,"sources":["/workspace/src/views/step-template/components/StepTemplateAsrBindDialog.vue"],"names":[],"mappings":"AACA,wCAAwC,mBAAmB,cAAc,eAAe,eAAe,CACtG,AACD,uCAAuC,eAAe,cAAc,cAAc,CACjF,AACD,4BAA4B,UAAU,CACrC","file":"StepTemplateAsrBindDialog.vue","sourcesContent":["\n.asr-bind-dialog__meta[data-v-efe259ce]{margin-bottom:16px;color:#606266;font-size:13px;line-height:1.8\n}\n.asr-bind-dialog__tip[data-v-efe259ce]{margin-top:4px;color:#909399;font-size:12px\n}\n.width-max[data-v-efe259ce]{width:100%\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"绑定录音风险配置","visible":_vm.dialogVisible,"width":"520px","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event},"open":_vm.onOpen,"close":_vm.onClose}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"asr-bind-dialog"},[_c('div',{staticClass:"asr-bind-dialog__meta"},[_c('div',[_vm._v("分步模板："+_vm._s(_vm.rowTitle || '-'))]),_vm._v(" "),_c('div',[_vm._v("模板 ID："+_vm._s(_vm.substepId || '-'))])]),_vm._v(" "),_c('el-form',{attrs:{"label-width":"100px","size":"medium"}},[_c('el-form-item',{attrs:{"label":"风险配置"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","keyword-key":"title","label-key":"title","value-key":"id","placeholder":"请选择录音风险配置","query-request":_vm.queryAudioAsrCheckTemplateSelect,"find-request":_vm.getAudioAsrCheckTemplate},model:{value:(_vm.asrTemplateId),callback:function ($$v) {_vm.asrTemplateId=$$v},expression:"asrTemplateId"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"asr-bind-dialog__tip"},[_vm._v("\n      一个分步模板最多绑定一个配置；清空并保存可解除绑定。\n      "),(_vm.viewConfigId)?_c('router-link',{attrs:{"to":("/audio-asr-check/template/update/" + _vm.viewConfigId),"target":"_blank"}},[_vm._v("查看配置\n      ")]):_vm._e()],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.saving},on:{"click":_vm.onSubmit}},[_vm._v("保存\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("分步模板管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1),_vm._v(" "),[_c('a',{staticStyle:{"position":"absolute","right":"10px","bottom":"18px"},attrs:{"href":"http://oss-cn-hangzhou.aliyuncs.com/sjpublicdev/191014/1/6e514eb94e4d9e648a06b4d09cb18c1a.pdf","target":"_blank"}},[_vm._v("标准模板使用说明\n      ")])]],2),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"rules":_vm.searchRules,"label-width":"96px","label-position":"right","clearable":"","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"关键字","prop":"keyword"}},[_c('el-input',{attrs:{"placeholder":"请输入关键字","clearable":""},model:{value:(_vm.search.keyword),callback:function ($$v) {_vm.$set(_vm.search, "keyword", $$v)},expression:"search.keyword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建人","prop":"createName"}},[_c('el-input',{attrs:{"placeholder":"请输入创建人","clearable":""},model:{value:(_vm.search.createName),callback:function ($$v) {_vm.$set(_vm.search, "createName", $$v)},expression:"search.createName"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","size":"mini","native-type":"submit"}},[_vm._v("搜索\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('router-link',{attrs:{"to":_vm.$route.params.type === '20' ? '/clb-step-template/create' : '/step-template/create'}},[_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-add","size":"small"}},[_vm._v("添加\n        ")])],1),_vm._v(" "),_c('router-link',{directives:[{name:"permission",rawName:"v-permission",value:(35002),expression:"35002"}],staticStyle:{"margin-left":"8px"},attrs:{"to":'/audio-asr-check/template'}},[_c('el-button',{attrs:{"size":"small"}},[_vm._v("录音风险配置\n        ")])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"分步模板ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"标题","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"detail","label":"描述","min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(scope.row.detail))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"步数"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"adminname","label":"创建人"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.adminid==null)?_c('span',[_vm._v("系统创建")]):_c('span',[_vm._v(_vm._s(scope.row.adminname))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createtime","label":"创建时间","min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.formatDate(scope.row.createtime))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updatetime","label":"更新时间","min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{on:{"click":function($event){return _vm.openVisibleLogDialog(scope.row.id)}}},[_vm._v(_vm._s(_vm.formatDate(scope.row.updatetime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"audio_asr_check_template_title","label":"录音风险配置","min-width":"220","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(Number(scope.row.audio_asr_check_template_id) > 0)?_c('router-link',{staticClass:"step-template-asr-config-link",attrs:{"to":("/audio-asr-check/template/update/" + (scope.row.audio_asr_check_template_id)),"target":"_blank"}},[_c('el-link',{attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.formatAsrConfigLabel(scope.row)))])],1):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"330"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":_vm.$route.params.type ? ("/clb-step-template/update/" + (scope.row.id)) : ("/step-template/update/" + (scope.row.id))}},[_c('el-button',{attrs:{"size":"mini","type":"primary"}},[(['', _vm.users.id].includes(scope.row.adminid) || parseInt(_vm.users.usertype) === 1)?_c('span',[_vm._v("\n                修改\n              ")]):_c('span',[_vm._v("\n                查看\n              ")])])],1),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.onCopy(scope.row.id)}}},[_vm._v("\n            复制\n          ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.onDelete(scope.row.id)}}},[_vm._v("\n            删除\n          ")]),_vm._v(" "),_c('el-button',{directives:[{name:"permission",rawName:"v-permission",value:(35002),expression:"35002"}],attrs:{"size":"mini","type":"warning"},on:{"click":function($event){return _vm.openAsrBindDialog(scope.row)}}},[_vm._v("录音风险配置\n          ")]),_vm._v(" "),_c('el-button',{directives:[{name:"permission",rawName:"v-permission",value:(211),expression:"211"}],staticStyle:{"margin":"10px"},attrs:{"size":"mini","type":"info"},on:{"click":function($event){return _vm.onBatchUpdateTask(scope.row.id)}}},[_vm._v("批量更新任务\n          ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('step-template-log',{attrs:{"visible":_vm.visibleLogDialog,"id":_vm.stepTemplateId},on:{"update:visible":function($event){_vm.visibleLogDialog=$event}}}),_vm._v(" "),_c('step-template-asr-bind-dialog',{attrs:{"visible":_vm.asrBindDialogVisible,"substep-id":_vm.asrBindRow && _vm.asrBindRow.id,"row-title":_vm.asrBindRow && _vm.asrBindRow.title},on:{"update:visible":function($event){_vm.asrBindDialogVisible=$event},"success":_vm.onRefresh}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/step-template-table.403a5c804d81b0699c3b.js